/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';


export const Follow = styled.button.attrs({
  className: 'btn btn-default',
})` 
`;
